import { __assign, __awaiter, __generator } from "tslib";
import { IconError, Loader } from '@anex/common';
import { Field, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import * as Yup from 'yup';
import { verificationSchema } from '../../common/validation';
import { AlertContainer, Error } from '../../components';
import { ExistingCustomer } from './components/ExistingCustomer';
export var CheckCustomerForm = observer(function (props) {
    var appStore = props.appStore, detailsStore = props.detailsStore, errors = props.errors, touched = props.touched, handleSubmit = props.handleSubmit, isSubmitting = props.isSubmitting, config = props.config;
    var _a = React.useState(''), wholesaler = _a[0], setWholesaler = _a[1];
    React.useEffect(function () {
        var isWholesalerCode = function (wholesalerCode) {
            return config.wholesaleCustomerCode === wholesalerCode;
        };
        if (config && isWholesalerCode('OT')) {
            setWholesaler('Accord');
        }
        if (config && isWholesalerCode('ALDI')) {
            setWholesaler('ALDI');
        }
        if (config && isWholesalerCode('ISPX')) {
            setWholesaler('Cmobile');
        }
        if (config && isWholesalerCode('PB')) {
            setWholesaler('Pronto Broadband');
        }
        if (config && isWholesalerCode('CTL')) {
            setWholesaler('Commtel');
        }
    }, [config]);
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3" },
            React.createElement("h2", null,
                wholesaler,
                " nbn\u2122 sign-up"),
            React.createElement("div", { className: "panel" },
                React.createElement(Loader, { loading: isSubmitting }),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-12" },
                        detailsStore.accordCustomer ? (React.createElement("p", null, "To continue, tell us your email address")) : (React.createElement(React.Fragment, null,
                            React.createElement("h3", null, "Great news! The nbn\u2122 is available at your place."),
                            React.createElement("p", null,
                                "To continue, are you already an ",
                                wholesaler,
                                " customer?"))),
                        React.createElement("form", { onSubmit: handleSubmit },
                            !detailsStore.accordCustomer ? (React.createElement("section", { className: "footer-buttons option-buttons" },
                                React.createElement("button", { type: "submit", className: "btn btn-next btn-option btn-new", onClick: function () {
                                        detailsStore.accordCustomer = true;
                                        appStore.gotoState(2);
                                    } }, "I'm new"),
                                React.createElement("button", { type: "submit", className: "btn btn-next btn-option btn-existing", onClick: function () {
                                        detailsStore.accordCustomer = true;
                                    } },
                                    "I'm with ",
                                    wholesaler))) : (React.createElement("div", { className: "form-group " },
                                React.createElement("label", { htmlFor: "lastName" }, "Email address"),
                                React.createElement(Field, { id: "emailAddress", name: "emailAddress", component: "input", className: "form-control shadow-alt " + (errors.emailAddress &&
                                        touched.emailAddress &&
                                        'error'), disabled: detailsStore.existingAccount }),
                                React.createElement(Error, { name: "emailAddress" }))),
                            React.createElement(AlertContainer, null),
                            detailsStore.existingAccount &&
                                detailsStore.accordCustomer && (React.createElement(ExistingCustomer, __assign({}, props))),
                            detailsStore.accordCustomer && (React.createElement("div", { className: "footer-buttons" },
                                React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: function () {
                                        detailsStore.accordCustomer = false;
                                        detailsStore.existingAccount = false;
                                        appStore.clearAlerts();
                                    } }, "Back"),
                                React.createElement("button", { type: "submit", className: "btn btn-next", disabled: isSubmitting }, detailsStore.existingAccount ? 'Sign in' : 'Next'))))))))));
});
export var CheckCustomer = inject('detailsStore', 'appStore', 'config')(observer(withFormik({
    handleSubmit: function (values, bag) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, appStore, detailsStore, error_1, alert_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = bag.props, appStore = _a.appStore, detailsStore = _a.detailsStore;
                    appStore.clearAlerts();
                    if (!detailsStore.accordCustomer) {
                        appStore.gotoState(2);
                        return [2];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!detailsStore.existingAccount) return [3, 3];
                    return [4, detailsStore.confirmIdentity(values)];
                case 2:
                    _b.sent();
                    return [3, 5];
                case 3: return [4, detailsStore.checkExistingAccount(values.emailAddress)];
                case 4:
                    _b.sent();
                    bag.resetForm({
                        dateOfBirth: values.dateOfBirth,
                        emailAddress: values.emailAddress,
                        lastName: values.lastName,
                    });
                    _b.label = 5;
                case 5:
                    bag.setSubmitting(false);
                    return [3, 7];
                case 6:
                    error_1 = _b.sent();
                    alert_1 = {
                        dismissible: false,
                        message: 'Something went wrong. Please try again.',
                        title: React.createElement(IconError, null),
                        type: 'danger',
                    };
                    appStore.addAlert(alert_1);
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); },
    mapPropsToValues: function (_a) {
        var detailsStore = _a.detailsStore;
        return detailsStore.details.formValues
            ? detailsStore.details.formValues
            : detailsStore.details.formInitialValues;
    },
    validateOnBlur: false,
    validationSchema: function (_a) {
        var detailsStore = _a.detailsStore;
        return detailsStore.existingAccount.accountExists
            ? verificationSchema
            : Yup.object().shape({
                emailAddress: Yup.string()
                    .email('Please enter a valid email')
                    .max(50, 'Email address is too long')
                    .required('Please enter a valid email'),
            });
    },
})(CheckCustomerForm)));
//# sourceMappingURL=index.js.map